import React from 'react';
import { Card, CardProps, CardActionArea, CardContent } from '@mui/material';
// COMPONENTS
import DetailViewCard from './DetailViewCard';
// HELPERS
import { getSubjectColor } from '../../helper';
// CONSTANTS
import { TP_COLORS } from '../../constants';

export interface ICardWithSubjectCode {
  subject: string;
  subjectCode: string;
  containerProps?: CardProps;
  onClick?: () => void;
  disabled?: boolean;
}

const CardWithSubjectCode: React.FC<ICardWithSubjectCode> = ({
  containerProps,
  subject,
  subjectCode,
  onClick,
  disabled,
}) => {
  return (
    <Card
      {...containerProps}
      elevation={
        containerProps && containerProps.elevation
          ? containerProps.elevation
          : 0
      }
    >
      <CardActionArea onClick={onClick} disabled={disabled}>
        <CardContent>
          <DetailViewCard
            containerProps={{
              sx: {
                background: getSubjectColor(subject),
              },
            }}
            title={subject}
            titleProps={{ sx: { color: TP_COLORS.white } }}
          />
          <DetailViewCard
            title={subjectCode}
            containerProps={{ sx: { mb: '0' } }}
            titleProps={{ fontWeight: 600 }}
          />
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default CardWithSubjectCode;
